import { render, staticRenderFns } from "./IssuesList.vue?vue&type=template&id=719df4d8&scoped=true&"
import script from "./IssuesList.vue?vue&type=script&lang=js&"
export * from "./IssuesList.vue?vue&type=script&lang=js&"
import style0 from "./IssuesList.vue?vue&type=style&index=0&id=719df4d8&lang=scss&scoped=true&"
import style1 from "./IssuesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719df4d8",
  null
  
)

export default component.exports